import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/api/api.service';
import { UtilService } from '../../../shared/util/util.service';

import { IInvoicePaymentService } from './iinvoice-payment.service';
import { Invoice } from '../invoice/invoice.model';
import { InvoiceLineItem } from '../invoice/invoice-lineitem.model';
import { InvoicePayment } from './invoice-payment.model';

//import { InvoiceSearchParams } from './invoice-search-params.model';
//import { InvoiceSearchResult } from './invoice-search-result.model';

@Injectable()
export class InvoicePaymentService implements IInvoicePaymentService {
  public _apiService: ApiService;
  public _utilService: UtilService;

  public constructor(apiService: ApiService, utilService: UtilService) {
    this._apiService = apiService;
    this._utilService = utilService;
  }

  public createInvoicePaymentRecordsForOpenInvoice = (invoiceNum: number, paymentDetails: InvoicePayment): void => {
    var url = 'Revenue/CreateInvoicePaymentRecordsForOpenInvoice/' + invoiceNum.toString();
    this._apiService.post(url, paymentDetails);
  };
}
